import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const container = document.getElementById('accommodation-overview');
if (container) {
    const {endpoint} = container.dataset;
    const root = ReactDOM.createRoot(container);
    root.render(
        <Router>
            <App endpoint={endpoint}/>
        </Router>
   );
}